import { render } from "./EquityAction.vue?vue&type=template&id=b70296f4&scoped=true"
import script from "./EquityAction.vue?vue&type=script&lang=js"
export * from "./EquityAction.vue?vue&type=script&lang=js"

import "./EquityAction.vue?vue&type=style&index=0&id=b70296f4&scoped=true&lang=scss"

import exportComponent from "/Users/johnguanlao/Desktop/wrk/CodeTogether/RSJI-Equity-Actions/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70296f4"]])

export default __exports__